export function getAccountHierarchyParentContext(childCount: number) {
    const childCompanyLabel = childCount === 1 ? 'company' : 'companies';
    return 'Parent company with ' + childCount + ' child ' + childCompanyLabel;
}
